var map = {
	"./Vector_10.svg": "99612",
	"./Vector_2.svg": "b078",
	"./Vector_3.svg": "12ed",
	"./Vector_4.svg": "509f",
	"./Vector_5.svg": "9bda",
	"./Vector_6.svg": "2b4a",
	"./Vector_7.svg": "6d4e",
	"./Vector_8.svg": "37eb",
	"./Vector_9.svg": "f35d",
	"./accordion-down.svg": "9216",
	"./approval.svg": "804b",
	"./arrow.svg": "c493",
	"./arrow_right.svg": "5fb7",
	"./backlog.svg": "0c4f",
	"./beta.svg": "9e15",
	"./calendar.svg": "287d",
	"./calendar_2.svg": "6ed2",
	"./call.svg": "f4f2",
	"./card.svg": "0cb1",
	"./chart.svg": "20e7",
	"./check-o.svg": "70c0",
	"./check-progress.svg": "1c63",
	"./check-solid.svg": "e889",
	"./comment-alt-solid.svg": "65e8",
	"./commentcross.svg": "24d6",
	"./comments-inbox.svg": "41cd",
	"./commentuser.svg": "5a7e",
	"./communication.svg": "63d4",
	"./company.svg": "5cd5",
	"./console.svg": "ef9b",
	"./contact.svg": "42b2",
	"./contacted.svg": "c0b1",
	"./converted.svg": "b467",
	"./create_note.svg": "564d",
	"./dashboard.svg": "7154",
	"./deals.svg": "9851",
	"./disqualified.svg": "ffb7",
	"./docs.svg": "0dd7",
	"./doublecheck.svg": "0963",
	"./edit.svg": "2fb0",
	"./email_o.svg": "8977",
	"./event.svg": "26f6",
	"./example.svg": "b6f9",
	"./expense.svg": "b95c",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./file-alt-solid.svg": "e0d2",
	"./file.svg": "493c",
	"./files.svg": "a10d",
	"./find-hospital.svg": "4ce0",
	"./flag.svg": "b238",
	"./folder.svg": "5a71",
	"./form.svg": "4576",
	"./forward.svg": "2163",
	"./group.svg": "76d4",
	"./help.svg": "86c0",
	"./home.svg": "0331",
	"./inbox.svg": "2e1c",
	"./info-o.svg": "d13d",
	"./lead.svg": "b5a2",
	"./link-solid.svg": "7d67",
	"./link.svg": "5fda",
	"./link_but.svg": "98fa",
	"./list-ol-solid.svg": "ceb4",
	"./log_activity.svg": "f0d7",
	"./meeting.svg": "b21e",
	"./nested.svg": "91be",
	"./new.svg": "11d9",
	"./open.svg": "d494",
	"./overdue2.svg": "7128",
	"./page.svg": "452c",
	"./pages.svg": "5d237",
	"./password.svg": "198d",
	"./pen-solid.svg": "d999",
	"./pin.svg": "f937",
	"./pin_.svg": "0c2f",
	"./pin_blue.svg": "7aa0",
	"./pin_blue_medium.svg": "6e61",
	"./pin_blue_small.svg": "0e57",
	"./pin_red.svg": "4b3d",
	"./pin_selected.svg": "4c55",
	"./planner.svg": "c5a3",
	"./plus-o.svg": "d2db",
	"./plus_o.svg": "d681",
	"./project.svg": "f61c",
	"./projects.svg": "8f1d",
	"./refresh.svg": "b41b",
	"./reply.svg": "7bb0",
	"./request.svg": "91da",
	"./resource.svg": "69cd",
	"./search_o.svg": "9de7",
	"./settings.svg": "9c15",
	"./sheduled.svg": "ef63",
	"./similar.svg": "0001",
	"./social.svg": "ade9",
	"./sort.svg": "6973",
	"./star.svg": "4e5a",
	"./table.svg": "dc78",
	"./tag.svg": "ac42",
	"./task.svg": "75ca",
	"./team-group.svg": "82e2",
	"./team.svg": "fb2b",
	"./time-entry.svg": "20e0",
	"./times.svg": "e5ec",
	"./timesheet.svg": "4cc8",
	"./trash.svg": "53bd",
	"./tree.svg": "0e8f",
	"./union.svg": "17bc",
	"./user.svg": "d88a",
	"./vector.svg": "80ff",
	"./warning-o.svg": "0336",
	"./workload.svg": "54c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";